export const formatPieChartData = (sumValue, items) =>
    items.map((item) => ({
        value: Math.round((Number(item.value) / Number(sumValue)) * 100),
        fullValue: item.fullValue,
        name: item.name,
        color: item.color,
    }));
